//@ts-nocheck
import React from 'react';
import { Box } from 'edenred-ui';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, {
  formatDate,
  parseDate
} from 'react-day-picker/moment';

import { momentDateFormat } from '@epi-constants/dateFormats';
import { ONE_DAY_IN_MS, TODAY } from '@epi-constants/downloadReports';
import { DateRangePickerStyles } from '@epi-components/DateRangePicker/DateRangePicker.styles';
import { ITerminationDatePicker } from '@epi-models/pages/Beneficiaries';
import { getApplicationLanguageId } from '@epi-store/application/application.selectors';
import { apiToDefaultDateFormat } from '@epi-helpers/dateHelper';

import { useTerminationDatePicker } from '../hooks';

export const TerminationDatePicker = (props: ITerminationDatePicker) => {
  const {
    isError,
    dayValue,
    title,
    disabledCustomDates,
    errorText,
    disableByDefault
  } = props;
  const { grey50 } = useTheme();
  const { t } = useTranslation();
  const language = useSelector(getApplicationLanguageId);
  const { day, ref, handleChange, handleOnDayClick } = useTerminationDatePicker(
    { ...props }
  );

  const getDisabledDays = () => {
    if (typeof disabledCustomDates === 'object') {
      return disabledCustomDates;
    }
    if (disabledCustomDates) {
      const disabledDate = new Date(disabledCustomDates);
      return TODAY > disabledDate
        ? { before: TODAY }
        : {
            before: new Date(disabledDate.getTime() + ONE_DAY_IN_MS)
          };
    }
    if (disableByDefault) {
      return () => true;
    }
    return { before: TODAY };
  };

  const formattedDate = apiToDefaultDateFormat(dayValue || day);

  return (
    <DateRangePickerStyles>
      <Box id="date-from" display="flex" flexDirection="column">
        {title && (
          <Box fontSize={12} fontWeight={400} color={grey50}>
            {title}
          </Box>
        )}
        {isError && (
          <Box color={'red'} fontSize={12}>
            {errorText
              ? errorText
              : t(
                  'containers.beneficiaries.detail.end_of_founds_calendar_err_msg'
                )}
          </Box>
        )}
        <DayPickerInput
          ref={ref}
          value={formattedDate}
          format={momentDateFormat}
          placeholder={momentDateFormat}
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            selectedDays: [day],
            disabledDays: getDisabledDays(),
            numberOfMonths: 1,
            keepFocus: true,
            onDayClick: handleOnDayClick,
            localeUtils: MomentLocaleUtils,
            locale: language
          }}
          onDayChange={handleChange}
          showOverlay={false}
          showOutsideDays
          hideOnDayClick={false}
        />
      </Box>
    </DateRangePickerStyles>
  );
};
